import React, { useEffect, useState } from "react";
import {
  Box,
  MenuItem,
  Menu,
} from "@mui/material";
import GroupLoansTable from "../GroupLoansTable/GroupLoansTable";
import GroupLoansCheckProperties from "../../pages/GroupLoans/GroupLoansCheckProperties/GroupLoansCheckProperties";
import GroupLoansTnC from "../../pages/GroupLoans/GroupLoansTnC/GroupLoansTnC";
import GroupLoansBalances from "../../pages/GroupLoans/GroupLoansBalances/GroupLoansBalances";
import GroupLoansPendingApprovals from "../../pages/GroupLoans/GroupLoansPendingApprovals/GroupLoansPendingApprovals";
import { commonRunQuery } from "../../util/API/loans";
import GroupLoansListMembers from "../../pages/GroupLoans/GroupLoansListMembers/GroupLoansListMembers";

function GroupMembershipTab({ selectedUser, selectedUserData }) {
    const [groupMemberships, setGroupMemberships] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [selectedView, setSelectedView] = useState(null);

    useEffect(() => {
        getListOfGroupMemberships();
    }, [selectedUser]);

    const getListOfGroupMemberships = async() => {
        try {
            const response = await commonRunQuery(285, 1);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setGroupMemberships(groupsArray);
              console.log("getListOfGroupMemberships_response==========",groupsArray);
            } else {
                setGroupMemberships([]);
            }
      
        } catch (error) {
            console.log("getListOfGroupMemberships_error==========",error);
            
        }
    }

    const columns = [
        {
          label: 'Group ID',
          getValue: (row) => row?.lgm?.groupid ?? ''
        },
        {
          label: 'Group Name',
          getValue: (row) => row?.lg?.groupname ?? ''
        },
        {
            label: 'Date Added',
            getValue: (row) => row?.lgm?.dateadded ?? ''
        },
        {
          label: 'Status',
          getValue: (row) => row?.lgm?.status ?? ''
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box className="groups-owned-tab-container" p={2}>
            {
                selectedView == null &&
                <Box>
                    <GroupLoansTable 
                        data={groupMemberships} 
                        columns={columns} 
                        title="Groups Membership" 
                        formatRow={formatedRows} 
                        handleMenuOpen={handleMenuOpen}
                        viewMenu={true}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            {selectedView === 'checkProperties' && <GroupLoansCheckProperties selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'viewTerms' && <GroupLoansTnC selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'groupBalances' && <GroupLoansBalances selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'pendingApprovals' && <GroupLoansPendingApprovals selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'piGroups' && <GroupLoansTnC selectedLoan={selectedLoan} setSelectedView={setSelectedView} />}
            {selectedView === 'listMembers' && <GroupLoansListMembers selectedLoan={selectedLoan} setSelectedView={setSelectedView} selectedView={selectedView} showMoreDetails={false} />}

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setSelectedView('listMembers');
                        handleMenuClose();
                    }}
                >
                    List Members
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('checkProperties');
                        handleMenuClose();
                    }}
                >
                    Check Properties
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('viewTerms');
                        handleMenuClose();
                    }}
                >
                    View T&C
                </MenuItem>
                <MenuItem
                    // disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                    onClick={() => {
                        setSelectedView('groupBalances');
                        handleMenuClose();
                    }}
                >
                    View Group Balances
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('pendingApprovals');
                        handleMenuClose();
                    }}
                >
                    Pending Approvals
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        setSelectedView('piGroups');
                        handleMenuClose();
                    }}
                >
                    Contributions By PI
                </MenuItem>
            </Menu>
        </Box>
    );
}

export default GroupMembershipTab;
